module.exports = __webpack_public_path__ + "product_search_favourites-c4c07356f0ed0c31a381e5d5ae29a477.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/common/onboarding/product_search_favourites.png
// module id = 1187
// module chunks = 2 3 4 5 6